import { render, staticRenderFns } from "./PsPatientDetailUpperBar.vue?vue&type=template&id=7b553d8a&scoped=true&"
import script from "./PsPatientDetailUpperBar.vue?vue&type=script&lang=js&"
export * from "./PsPatientDetailUpperBar.vue?vue&type=script&lang=js&"
import style0 from "./PsPatientDetailUpperBar.vue?vue&type=style&index=0&id=7b553d8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b553d8a",
  null
  
)

export default component.exports